export default {
	// baseUrl: "http://dowelltech.wjruanjian.com",
	// baseUrl: "http://www.mingpinhui.cc",
	// baseUrl: "http://www.tczg.xyz/"
	baseUrl: "https://www.huigen.cc/api.php/",
	baseUrlimg: "https://www.huigen.cc"
}